import { FunctionComponent, useState } from 'react';
import classnames from 'classnames';

import { Routes } from 'types/routes';

import { prettierPhoneNumber } from 'utils/string';

import Button, { ButtonElements, ButtonIconPositions, ButtonIconTypes, ButtonLayouts, ButtonVariants } from 'components/layout/Button';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';
import SaveButton from 'components/modules/public/layout/controls/SaveButton';
import ShareButton from 'components/modules/public/layout/controls/ShareButton';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageJobSectionJobBlocksJobFooter: FunctionComponent<Props> = ({
    job,
    jobCity,
    buttonProps,
    onApply,
}) => {
    const getButtonProps = () => {
        if(job?.isCvRequired) return { ...buttonProps?.apply };
        if(!job?.isCvRequired) return { ...buttonProps?.applyCvFree };
    };
    const [isBtnActice, setIsBtnActive] :[ boolean, Function] = useState(false);
    const  handleClick = () => {
        setTimeout(()=>{
            setIsBtnActive(true);
        }, 200);
    };
    return (
        <StyledComponent
            className="public-page-job-section-job-blocks-job-footer"
        >
            <LayoutContainer size={Sizes.Small}>
                {!job?.isClosed && (
                    <>
                        <div className="top">
                            <div className="btn-container">
                                <Button
                                    {...getButtonProps()}
                                    onClick={() => onApply()}
                                />
                                {job.companyPhone && (
                                    <Button
                                        variant={ButtonVariants.Outline}
                                        layout={ButtonLayouts.Wide}
                                        onClick={handleClick}
                                        element={ButtonElements.Anchor}
                                        className={classnames(
                                            'phone-btn',
                                            { active : isBtnActice }
                                        )}
                                        hoverText={prettierPhoneNumber(job?.companyPhone)}
                                        href={isBtnActice ? `tel:+48${job?.companyPhone}` : null}
                                        icon={{
                                            type: ButtonIconTypes.Image,
                                            position: ButtonIconPositions.Before,
                                            alt: 'Zadzwoń',
                                            value: '/images/navigation-icons/phone-r.svg',
                                        }}
                                        disabled={job?.isClosed}

                                    >
                                        {buttonProps?.phone?.label}
                                    </Button>

                                )}
                            </div>
                        </div>

                        <div className="main">
                            <div className="control">
                                <SaveButton
                                    jobId={job?.id}
                                    cityId={jobCity?.city?.id}
                                />
                            </div>
                            <div className="control">
                                <ShareButton
                                    route={Routes.PublicJob}
                                    variables={{
                                        slug: job.slug,
                                    }}
                                />
                            </div>
                        </div>
                    </>
                )}
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobFooter;